import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { DatasetRecord, UpdateDatasetRequest } from "../DatasetRecord";

import { datasetQueryKeys } from "./useDatasetsQuery";

interface UpdateDataset {
  datasetId: string;
  resourceOwnerId: string;
  updates: UpdateDatasetRequest;
}

export function useUpdateDataset() {
  const { datasetService } = useDomainServices();

  const queryClient = useQueryClient();

  return useMutation<DatasetRecord, Error, UpdateDataset>({
    mutationFn: async ({ datasetId, resourceOwnerId, updates }) => {
      return await datasetService.updateDataset(datasetId, updates, {
        resourceOwnerId,
      });
    },

    onSuccess: (datasetRecord) => {
      queryClient.setQueryData(
        ["datasetRecord", datasetRecord.dataset_id],
        datasetRecord,
      );
      void queryClient.invalidateQueries({ queryKey: datasetQueryKeys.all });
      void queryClient.invalidateQueries({
        queryKey: datasetQueryKeys.orgTags(datasetRecord.org_id),
      });
    },
  });
}
